module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_IX"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-ix"
    }
  }, [_vm._v("KEY TO PANELS")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-ix"
    }
  }, [_vm._v("This key to the panels helps locate the special and suggested exercises that occur throughout the volume. It should be noted that the panels are not exhaustive treatments of topics, and are meant to be read and used in their contexts. Panels sometimes cross-refer to other parts of the book.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-ix"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-ix"
    }
  }, [_vm._v("A number of themes may be picked up by looking carefully across the different kinds of boxes (for example: Israel, metaphor, prophecy/prophets, rhetoric).")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv-ix"
    }
  }, [_vm._v("THINK ABOUT’ PANELS")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "Tabpix"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "65%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#enc-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Between salvation and salvation")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#enc-110",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Zechariah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-008"
    }
  }, [_vm._v("Canon and biblical theology")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-008"
    }
  }, [_c('b', [_vm._v("Introduction")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Circumcision of the heart’")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-022",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeremiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Covenants’")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-116",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Malachi")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel among the prophets?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-058",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel and Esther")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-046",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel and Revelation")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-060",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel as intercessor")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-059",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel’s stories as history?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-047",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Delusions of grandeur")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-010",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Deterministic’ view of history?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-057",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Disenchantment’ of the world")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-070",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hosea")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#enc-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Echoes of the past")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#enc-103",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Haggai")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Election")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-079",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Amos")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ezekiel 20 as ‘rhetoric’")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-038",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fall of Babylon")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-016",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free will")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-029",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeremiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s call")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-021",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeremiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s presence in Ezekiel’s structure")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-032",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness and love")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-071",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hosea")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hosea on kings")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-068",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hosea")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘House of Jehu’ – different views in Hosea and Kings?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-065",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hosea")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How can the exiles be ‘Israel’?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-014",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How long is seventy years?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-027",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeremiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap15#enc-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Humility and poverty")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap15#enc-101",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Zephaniah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Idolatry")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-069",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hosea")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intercession")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-034",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 35 as centrepiece")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-013",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is there only one point?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-088",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jonah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jerusalem as female")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-035",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonah as history?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-086",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jonah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice and righteousness")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-082",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Amos")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justness of judgement")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-083",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Obadiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kinds of writing in Hosea")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-064",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hosea")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metaphor of locusts")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-074",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metaphors and similes")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-072",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hosea")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Mountain of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s house’")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-092",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Micah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OAN as rhetoric")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-039",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obadiah in relation to Amos")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#enc-084",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Obadiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Political planning")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-017",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#enc-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Power and weakness")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#enc-097",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Nahum")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pride of kings")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-053",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophecies in new settings")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-018",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophecy, Jews and Christians")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-020",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophetic symbolic actions")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-033",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophetic words in new contexts")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-075",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Joel before Amos")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-061",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Book of the Twelve")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-007"
    }
  }, [_vm._v("Rhetoric and speech-acts")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-007"
    }
  }, [_c('b', [_vm._v("Introduction")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rome, Babylon and the gospel")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-019",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Should Christians tithe?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-114",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Malachi")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Song of the vineyard as poetry")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-011",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spirit (the)")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-076",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Universalism’ and Judaism")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-087",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jonah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#enc-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting for God to act")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#enc-098",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Habakkuk")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting for salvation")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-096",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Micah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What is Jonah like?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-085",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jonah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s in a (prophet’s) name?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-080",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Amos")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why does God judge the nations?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-077",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Amos")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom and understanding")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-054",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#enc-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zechariah 9—14 in the passion-narratives")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#enc-111",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Zechariah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#enc-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zerubbabel as messiah?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#enc-104",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Haggai")])])])])])])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_X"
    }
  }, [_vm._v("‘DIGGING DEEPER’ PANELS")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "Tab1px"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "65%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book of the Twelve as one book?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#enc-062",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Book of the Twelve")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comparison")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-023",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeremiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Covenant accusation’")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-094",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Micah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel 11 and history")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-052",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel and 1 Maccabees")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-055",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Debt-slavery")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-078",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Amos")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine initiative and human response")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-037",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine warrior")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-026",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeremiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-002"
    }
  }, [_vm._v("Finding prophets")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-002"
    }
  }, [_c('b', [_vm._v("Introduction")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s affections")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-115",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Malachi")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Holiness’")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-043",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hosea’s ‘marriage’")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-066",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hosea")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israel’s return to its land")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-028",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeremiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah’s ‘confessions’")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-025",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeremiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literary techniques; more on genre")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#enc-089",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jonah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malachi and Nehemiah")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-112",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Malachi")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Messianic text?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-051",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-006"
    }
  }, [_vm._v("Poetry, metaphor and theology")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-006"
    }
  }, [_c('b', [_vm._v("Introduction")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-003"
    }
  }, [_vm._v("Prophecy and Wisdom")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-003"
    }
  }, [_c('b', [_vm._v("Introduction")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-004"
    }
  }, [_vm._v("Prophets and Psalms")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-004"
    }
  }, [_c('b', [_vm._v("Introduction")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophetic allusions")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-050",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reinterpretation of prophecies")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-040",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Temple and security")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#enc-024",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Jeremiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two political allegories")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-036",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Was there an Ezekiel ‘school’?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-031",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Wise’ (the)")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-056",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What do names tell us about the prophets?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#enc-081",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Amos")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#enc-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who ‘repented’?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#enc-107",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Zechariah")])])])])])])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_X"
    }
  }, [_vm._v("OTHER PANELS")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "Tab2px"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "65%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apocalyptic")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-048",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chronology in Ezekiel")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-030",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#enc-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Cognitive dissonance’")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#enc-106",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Haggai")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Covenant with Levi’?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-113",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Malachi")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap15#enc-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cultic prophets")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap15#enc-100",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Zephaniah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deuteronomy and Hosea")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-063",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hosea")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divorce")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#enc-117",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Malachi")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#enc-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Editing of Haggai, Zechariah 1—8 and Chronicles")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#enc-102",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Haggai")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God as author of evil?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-042",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interbiblical quotations")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#enc-073",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Joel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is prophecy predictive?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-009",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#enc-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Jealous’ God")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#enc-108",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Zechariah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Key dates for the Book of Daniel")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-044",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#enc-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knowing God’s will: Did prophecy cease after the exile?")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#enc-109",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Zechariah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life after death in the Old Testament")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-012",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-005"
    }
  }, [_vm._v("More on ‘Israel’")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-005"
    }
  }, [_c('b', [_vm._v("Introduction")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘On the third day’ (Hosea 6:2)")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#enc-067",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Hosea")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Nabonidus")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-045",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophetic sayings and their backgrounds")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-091",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Micah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophetic tradition: How oracles got into books")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-090",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Micah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-001"
    }
  }, [_vm._v("Prophets as a section of the Old Testament canon")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre4#enc-001"
    }
  }, [_c('b', [_vm._v("Introduction")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roles of priests and Levites")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#enc-041",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ezekiel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Servant Songs")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#enc-015",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Isaiah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shepherd-messiah")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-093",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Micah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Son of Man")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#enc-049",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Daniel")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Too much sacrifice")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#enc-095",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Micah")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#enc-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yahweh and the temple")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#enc-105",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Haggai")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap15#enc-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zephaniah and Jeremiah")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap15#enc-099",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Zephaniah")])])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0